/**
 * GLSanger 认证工具函数
 * 用于处理 indigo 服务的 JWT 认证
 */

/**
 * 获取当前用户的 JWT access token
 * @returns JWT access token 或 null
 */
export const getAccessToken = (): string | null => {
  try {
    const tokenData = localStorage.getItem('token')
    if (!tokenData) return null
    
    const token = JSON.parse(tokenData)
    return token.accessToken || null
  } catch (error) {
    console.error('Failed to get access token:', error)
    return null
  }
}

/**
 * 检查用户是否已登录
 * @returns 是否已登录
 */
export const isAuthenticated = (): boolean => {
  const token = getAccessToken()
  return !!token
}

/**
 * 打开 GLSanger 页面并传递 JWT token
 * @param baseUrl GLSanger 基础 URL 或路由（同域），默认为 '/glsanger/'
 */
export const openGLSanger = (baseUrl = '/glsanger/'): void => {
  if (!isAuthenticated()) {
    console.error('User is not authenticated')
    alert('请先登录后再访问 GLSanger')
    return
  }

  const token = getAccessToken()
  if (!token) {
    console.error('No access token available')
    alert('无法获取认证令牌，请重新登录')
    return
  }

  // 将 token 作为 URL 参数传递
  const normalizedBaseUrl = baseUrl.startsWith('/') ? baseUrl : `/${baseUrl}`
  const url = baseUrl.startsWith('http')
    ? new URL(baseUrl)
    : new URL(normalizedBaseUrl, window.location.origin)
  url.searchParams.set('token', token)
  
  // 在新窗口中打开
  window.open(url.toString(), '_blank')
}

/**
 * 为 GLSanger API 请求创建带认证头的配置
 * @returns 包含 Authorization 头的配置对象
 */
export const createAuthHeaders = (): { Authorization: string } | {} => {
  const token = getAccessToken()
  if (!token) {
    console.warn('No access token available for API request')
    return {}
  }
  
  return {
    Authorization: `Bearer ${token}`
  }
}
